import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { SocialExportGetConnectionStateDto } from '@mi-front/api-v2';
import { Avatar, AvatarProps, Theme } from '@mui/material';

type Props = {
  connection: Pick<SocialExportGetConnectionStateDto, 'profile'>;
  platform: SocialPlatform;
} & Omit<AvatarProps, 'src' | 'children'>;

/**
 * Connection avatar: profile photo when the platform has a user profile, otherwise the
 * platform brand icon (also used as fallback when photo is missing).
 */
export function ConnectionAvatar({ connection, platform, sx, ...avatarProps }: Props) {
  const usePlatformIcon = !platform.hasUserProfile || !connection.profile.photo;

  return (
    <Avatar
      src={usePlatformIcon ? undefined : connection.profile.photo || undefined}
      sx={[
        {
          bgcolor: (theme: Theme) => (theme.palette.mode === 'dark' ? 'grey.800' : 'grey.200'),
        },
        ...(Array.isArray(sx) ? sx : [sx ?? {}]),
      ]}
      {...avatarProps}
    >
      {usePlatformIcon ? platform.Icon({ colored: true }) : null}
    </Avatar>
  );
}
